export default {
  root: {
    '&[class*="listDivider"]': {
      marginTop: '10px',
      marginBottom: '10px',
    }
  }
}